<p class="mention-comment cursor-default">
    <ng-container *ngFor="let part of comment() | parseMention">
        @if (part.type === 'text') {
        <span>{{part.value}}</span>
        }

        @if (part.type === 'mention') {
        <div class="relative group inline-block my-1 px-1 bg-slate-200 rounded-full text-[0.9rem]">
            {{prefix}}{{part.displayName}}
            <div class="absolute bottom-full left-1/2 -translate-x-1/2 mb-1 w-max max-w-xs rounded bg-gray-800 px-2 py-1 text-xs text-white 
           opacity-0 invisible transition-opacity duration-200 group-hover:opacity-100 group-hover:visible">
                {{part.title}}
            </div>
        </div>
        }
    </ng-container>
</p>